import { Helmet } from "react-helmet-async"
import React from "react"
import {
  ReviewCarusel,
  DirectionTabs,
  WhyChooseUs,
  Licence,
  FreeCourses,
  Intro,
  FourSteps,
  HomeHero,
} from "../../widgets/home"

// ----------------------------------------------------------------------

export function HomePage(): React.JSX.Element {
  return (
    <>
      <Helmet>
        <title>
          Учебно-методический центр современного образования в сфере фитнеса
        </title>
        <meta property="og:title" content="Учебно-методический центр современного образования в сфере фитнеса"/>

        <meta name="description"
              content="Фитнес-обучения по всем направлениям. Станьте сертифицированным специалистом и повысьте свою квалификацию"/>
        <meta property="og:description"
              content="Фитнес-обучения по всем направлениям. Станьте сертифицированным специалистом и повысьте свою квалификацию"/>

        <meta property="og:url" content="https://bodycoach.pro/"/>
        <link rel="canonical" href="https:///bodycoach.pro/"/>
        <meta property="og:site_name" content="bodycoach.pro"/>

        <meta name="keywords"
              content="фитнес,фитнес-обучения,образовательный центр,образование,сертифицированный специалист,нутрициология,нутрициолог,фитнес-тренер,bodycoach,body coach"/>
      </Helmet>

      <HomeHero/>
      <WhyChooseUs/>
      <DirectionTabs/>
      <FourSteps/>
      <FreeCourses/>
      <ReviewCarusel/>
      <Licence/>
      <Intro/>
    </>
  )
}
